export const INSURANCE_VALUES_SP_TEST_VALUES = [
  'QATTRINSVALUES-B1',
  'QATTRINSVALUES-B2',
  'QATTRINSVALUESMULTI-B1',
  'QATTRINSVALUESMULTI-B2',
]
